<template>
    <div>
        <component v-if="currentComponent" :is="currentComponent" ref="mainPageComponent" />
        <el-card v-else>
            <h1>{{$t('contrato_rastreabilidade.words.module_not_available')}}</h1>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'MainRegistrantPageIndex',
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/traceability-contract/views/pages/main/registrant-py.vue'
                    )
            }
        };
    },
    computed: {
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss"></style>
